<header class="app-header d-flex align-items-center justify-content-between px-4">
  <div class="d-flex align-items-center gap-3">

    <button
      class="app-header__menu-btn d-flex align-items-center justify-content-center border-0 bg-transparent rounded-2 d-block d-md-none"
      (click)="slideMenuService.showed = !slideMenuService.showed">
      <i class="material-icons">menu</i>
    </button>

    @if(router.url.includes('branches')) {
      <div ngbDropdown class="d-none d-md-block">
        <button type="button" class="app-header__branch-btn d-flex align-items-center gap-2 rounded-2 fw-semibold" id="dropdownBranch" ngbDropdownToggle>
          <i class="material-icons app-header__branch-icon">store</i>
          <span>{{ branchService.currentBranch?.name }}</span>
          <i class="material-icons app-header__chevron">expand_more</i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBranch" class="app-header__dropdown rounded-2">
          <a
            [routerLink]="['/dashboard']"
            ngbDropdownItem
            class="app-header__dropdown-item d-flex align-items-center gap-2 rounded-1">
            <i class="material-icons">business</i>
            Todas las sucursales
          </a>
          <div class="dropdown-divider"></div>
          @for(branch of branchService.branches; track branch.idBranch) {
            <a
              [routerLink]="['/branches', branch.idBranch]"
              ngbDropdownItem
              class="app-header__dropdown-item d-flex align-items-center gap-2 rounded-1">
              {{ branch.name }}
            </a>
          }
        </div>
      </div>

      <!-- Mobile branch selector -->
      <div ngbDropdown class="d-block d-md-none">
        <button type="button" class="app-header__branch-btn d-flex align-items-center gap-2 rounded-2 fw-semibold" id="dropdownBranchMobile" ngbDropdownToggle>
          <i class="material-icons app-header__branch-icon">store</i>
          <span>{{ branchService.currentBranch?.name }}</span>
          <i class="material-icons app-header__chevron">expand_more</i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBranchMobile" class="app-header__dropdown rounded-2">
          <a
            [routerLink]="['/dashboard']"
            ngbDropdownItem
            class="app-header__dropdown-item d-flex align-items-center gap-2 rounded-1">
            <i class="material-icons">business</i>
            Todas las sucursales
          </a>
          <div class="dropdown-divider"></div>
          @for(branch of branchService.branches; track branch.idBranch) {
            <a
              [routerLink]="['/branches', branch.idBranch]"
              ngbDropdownItem
              class="app-header__dropdown-item d-flex align-items-center gap-2 rounded-1">
              {{ branch.name }}
            </a>
          }
        </div>
      </div>
    }

  </div>

  <div class="d-flex align-items-center">
    <div ngbDropdown class="d-inline-block">
      <button type="button" class="app-header__user-btn d-flex align-items-center gap-2 rounded-2 fw-medium border-0 bg-transparent" id="dropdownUser" ngbDropdownToggle>
        <div class="app-header__avatar d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 fw-bold">
          {{ authService.currentUser?.name?.charAt(0) }}{{ authService.currentUser?.paternalSurname?.charAt(0) }}
        </div>
        <span class="app-header__user-name text-truncate d-none d-sm-inline">
          {{ authService.currentUser?.getFullName() }}
        </span>
        <i class="material-icons app-header__chevron">expand_more</i>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownUser" class="app-header__dropdown rounded-2">
        <a
          [routerLink]="['/dashboard']"
          ngbDropdownItem
          class="app-header__dropdown-item d-flex align-items-center gap-2 rounded-1">
          <i class="material-icons">business</i>
          Sucursales
        </a>
        <div class="dropdown-divider"></div>
        <button
          ngbDropdownItem
          class="app-header__dropdown-item app-header__dropdown-item--danger d-flex align-items-center gap-2 rounded-1"
          (click)="authService.signOut()">
          <i class="material-icons">logout</i>
          Cerrar sesión
        </button>
      </div>
    </div>
  </div>
</header>
